/**
 * Domain Service
 * CD-283: My Domains list page
 * CD-284: Add/Edit domain modal
 * CD-285: Schedule configuration UI
 *
 * API service for domain management operations
 */
import api from './api'

export default {
  /**
   * List user domains with pagination
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.limit - Items per page (default: 20)
   * @param {boolean} params.enabled - Filter by enabled status
   */
  async listDomains(params = {}) {
    return api.get('/domains', { params })
  },

  /**
   * Get single domain by ID
   * @param {number} domainId - Domain ID
   */
  async getDomain(domainId) {
    return api.get(`/domains/${domainId}`)
  },

  /**
   * Create a new domain
   * @param {Object} data - Domain data
   * @param {string} data.domain_name - Domain name
   * @param {string} data.schedule_frequency - daily/weekly/monthly or null
   * @param {number} data.schedule_day_of_week - 0-6 for weekly
   * @param {number} data.schedule_day_of_month - 1-31 for monthly
   * @param {string} data.schedule_time - HH:MM format
   * @param {string} data.scan_depth - quick/standard/deep/complete
   * @param {boolean} data.is_enabled - Enable scheduled scans
   */
  async createDomain(data) {
    return api.post('/domains', data)
  },

  /**
   * Update an existing domain
   * @param {number} domainId - Domain ID
   * @param {Object} data - Update data
   */
  async updateDomain(domainId, data) {
    return api.put(`/domains/${domainId}`, data)
  },

  /**
   * Delete a domain
   * @param {number} domainId - Domain ID
   */
  async deleteDomain(domainId) {
    return api.delete(`/domains/${domainId}`)
  },

  /**
   * Enable domain scheduling
   * @param {number} domainId - Domain ID
   */
  async enableDomain(domainId) {
    return api.post(`/domains/${domainId}/enable`)
  },

  /**
   * Disable domain scheduling
   * @param {number} domainId - Domain ID
   */
  async disableDomain(domainId) {
    return api.post(`/domains/${domainId}/disable`)
  },

  /**
   * Initiate scan for domain
   * @param {number} domainId - Domain ID
   */
  async scanDomain(domainId) {
    return api.post(`/domains/${domainId}/scan`)
  },

  /**
   * Check if domain has active scan in progress
   * CD-208: Enhanced UX for domain deletion
   * @param {number} domainId - Domain ID
   * @returns {Promise<{has_active_scan: boolean, scan_id: string|null, message: string}>}
   */
  async checkActiveScan(domainId) {
    return api.get(`/domains/${domainId}/check-active-scan`)
  }
}
